import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import { HoleriteLista } from 'Component/Holerite';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarHoleritesQuery } from 'View/Service/Default/Holerites';

const Holerites = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: { holerites, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarHoleritesQuery({
    page: searchParams.get('pagina') || 1,
    contain: ['VinculosEmpregaticios.Empresas'],
    options: { usuario_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/usuarios/editar/${id}/holerites/adicionar`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={holerites?.length}
        redirecionar={`/usuarios/editar/${id}/holerites/adicionar`}
      />
      <div className="bg-white shadow-sm rounded">
        {holerites?.map((folha) => (
          <HoleriteLista
            key={`${folha.id}-${folha.modificado}`}
            dados={folha}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Holerites;
